/**
 * Liferay legacy code used to scroll to an anchor element immediately after the page is loaded.
 * The native function "maybeRepositionScrollToHashedAnchor" is called after but do not modify the scroll position.
 */
function getNodeOffset(node) {
	let [offsetLeft, offsetTop] = [0, 0];
	do {
		offsetLeft += node.offsetLeft;
		offsetTop += node.offsetTop;
		node = node.offsetParent;
	} while (node);

	return {
		offsetLeft,
		offsetTop,
	};
}

Liferay.once('SPAReady', () => {
    const hash = window.location.hash;
    if (hash) {
        const anchorElement = document.getElementById(hash.substring(1));
        if (anchorElement) {
            const {offsetLeft, offsetTop} = getNodeOffset(anchorElement);
            window.scrollTo(offsetLeft, offsetTop);
        }
    }
});